// extracted by mini-css-extract-plugin
export default {"loaderContainer":"CounterSkelleton_loaderContainer__Ddgce","loader":"CounterSkelleton_loader__5F9sV"};